import * as fb from 'js/facebook'
import api from 'js/api'

function authenticateWithFacebook(token) {
  return api('POST', 'gatekeeper/v1/login/facebook', {
    token,
  }).then(({ access_token, expires_at, refresh_token }) => ({
    access_token,
    expires_at,
    refresh_token,
  }))
}

export const loginWithFacebook = (token) => {
  if (token) return authenticateWithFacebook(token)

  return fb.login().then(({ token }) => authenticateWithFacebook(token))
}
